"use client";

import { USERDATA_KEY } from "@/providers/app-data-provider";
import { ApiMeReponse } from "@jace/api";
import { useQuery } from "@tanstack/react-query";

export function useFeatureFlagEnabled(flag: string): boolean | undefined {
	const { data } = useQuery<ApiMeReponse>({
		queryKey: USERDATA_KEY,
		enabled: false,
	});

	return data?.feature_flags?.[flag] as boolean | undefined;
}
